<template>
  <div class="container-fluid mt-2">
    <h2>Kundenstammdaten</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button class="btn btn-secondary" @click="prevPage()" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" @click="nextPage()" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <button class="btn btn-secondary"><font-awesome-icon icon="search"/></button>
        </div>
        <input class="form-control" id="search" @keyup="updateSearch()" v-model="search" type="text"/>
      </div>
      <div v-if="smbenabled" class="btn-group">
        <button @click="showUpload" class="btn btn-outline-primary">Importieren</button>
        <a v-if="smbenabled" href="/trendshop.proxy.web/files/CSVDokumentation.pdf" download><button class="btn btn-outline-secondary">Dokumentation</button></a>        
      </div>
    </div>
    <b-table no-local-sorting @sort-changed="updateSort" @row-clicked="open" class="mt-3" striped hover :items="rows" :fields="fields"></b-table>

    <!-- smb data upload -->
    <b-modal title="Daten importieren" id="smbUpload" @ok="uploadData">
      <div class="input-group">
        <div class="input-group-prepend">
          <button class="input-group-text">Kunden</button>
        </div>
          <input class="form-control" type="file" id="datafile"/>
      </div>
      <span class="text-muted">CSV Datei mit den aktuellen Kundendaten</span>
      <div class="row" v-show="uploading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </b-modal>
  </div>
</template>

<script>
import router from '@/router'
import config from '@/modules/config.js'
import customers from '@/modules/customers.js'

export default {
  name: 'CustomerList',
  components: {
  },
  created: function() {
    this.fetchData();
    var self = this;
    config.checkSmbEnabled(this,function(data) {
      console.log(data);
      self.smbenabled = data;
    });
  },
  data() {
    return {
      rows: [],
      fields: [
        { key: 'map_id', label: 'Kunden-Nr', sortable: true},
        { key: 'title', label: 'Name', sortable: true},
        { key: 'street', label: 'Strasse'},
        { key: 'pcode', label: 'PLZ', sortable: true},
        { key: 'city', label: 'Stadt', sortable: true},
        { key: 'handid', label: 'Vertreter', sortable: true},
        { key: 'email', label: 'E-Mail' },
      ],
      search:"",
      uploading: false,
      smbenabled: false,
    }
  },
  methods: {
    showUpload() {
      this.$bvModal.show('smbUpload');
    },
    uploadData() {
      var self = this;

      console.log('upload data');

      var file   = document.getElementById('datafile');

      // check for csv article data upload
      if (file.files.length > 0) {

        this.uploading = true;

        var fd   = new FormData();
        fd.append("filename",file.files[0]);
        config.post(this,config.baseUrl + 'rest/smallbusiness/customer','Kundendaten import',fd,function(data) {
          console.log(data);
          self.$bvModal.hide('smbUpload');
          self.uploading = false;
          self.$bvToast.toast('Upload abgeschlossen.',{variant: 'success', title: 'Kundendaten'});
        });
      }
    },
    updateSort: function(data) {
      var sort = data.sortBy;
      if (sort == 'handid') sort = 'handId';
      if (sort == 'city') sort = 'location';
      customers.viewparams.sdir = (data.sortDesc ? 'desc' : 'asc');
      customers.viewparams.sort = sort;
      this.fetchData();
    },
    open: function(row) {
      router.push({ name: 'CustomerView', params: {customerid: row.map_id }});
    },
    fetchData: function() {
      var self = this;
      customers.list(function(data) {
        self.rows = data.rows;
      })
    },
    prevPage: function() {
      if (customers.viewparams.page > 1) {
        customers.viewparams.page--;
        this.fetchData();
      }
    },
    nextPage: function() {
      if (this.rows.length > 0) {
        customers.viewparams.page++;
        this.fetchData();
      }
    },
    updateSearch: function() {
      customers.viewparams.search = this.search;
      this.fetchData();
    },
  },
}
</script>
